module.exports = __webpack_public_path__ + "img/touxiangwoman.1b4003c6.png";